import { Action } from '@ngrx/store';
import * as Actions from './bulk-move-mobile-logbooks.actions';
import { IBulkMoveMobileLogbookState } from './bulk-move-mobile-logbooks.model';

export const bulkMoveMobileLogbookState: IBulkMoveMobileLogbookState = {
  bulkMoveMobileLogbookModalDataLoading: false,
  bulkMoveMobileLogbookModalDataLoaded: false,
};

export function bulkMoveMobileLogbookReducer(
  state: IBulkMoveMobileLogbookState = bulkMoveMobileLogbookState,
  baseAction: Action,
): IBulkMoveMobileLogbookState {
  const action: Actions.BulkMoveMobileLogbooksActions = baseAction as Actions.BulkMoveMobileLogbooksActions;
  switch (action.type) {
    case Actions.GET_BULK_MOVE_LOGBOOK_MODAL_DATA:
      return {
        ...state,
        bulkMoveMobileLogbookModalDataLoading: true,
        bulkMoveMobileLogbookModalDataLoaded: false,
      };
    case Actions.GET_BULK_MOVE_LOGBOOK_MODAL_DATA_COMPLETED:
      return {
        ...state,
        bulkMoveMobileLogbookModalDataLoading: false,
        bulkMoveMobileLogbookModalDataLoaded: true,
      };
    default:
      return state;
  }
}
